<script>
export default {
  name: "DidoDownloadButtonAttachment",
};
</script>

<script setup>
import { ref, watch, computed } from "vue";

// define Props
const props = defineProps({
  attachment: { type: Object, required: true },
  selectable: { type: Boolean, required: false, default: false },
  selectedLinks: { type: Array, required: false, default: () => [] },
});

// define emits
const emit = defineEmits(["update-selected-links"]);

// define Reactive Data
const selected = ref(false);

// define computed datas
const buttonTooltip = computed(() => {
  return props.attachment ? `Télécharger le fichier '${title.value}'` : null;
});
const title = computed(() =>
  props.attachment ? props.attachment.title : null,
);
const link = computed(() => (props.attachment ? props.attachment.url : null));

// define watchers
watch(
  () => [props.attachment, props.selectedLinks],
  () => checkSelectedLinks(),
);

// define Methods
const checkSelectedLinks = () => {
  if (props.attachment)
    selected.value = !!props.selectedLinks.find((l) => l === link.value);
};
const toggleLink = (link) => {
  if (selected.value) emit("update-selected-links", { action: "add", link });
  if (!selected.value)
    emit("update-selected-links", { action: "remove", link });
};

// Init
checkSelectedLinks();
</script>

<template>
  <div v-if="props.attachment">
    <QBtnGroup unelevated class="no-border-radius">
      <QBtn
        :href="link"
        target="_blank"
        color="secondary"
        dense
        label="télécharger le fichier"
        :title="buttonTooltip"
        no-caps
        size="sm"
        icon="mdi-download"
        class="q-pr-xs"
      />
      <QBtn
        v-if="props.selectable"
        color="white"
        dense
        size="sm"
        unelevated
        class="q-ml-xs"
      >
        <QCheckbox
          v-model="selected"
          dense
          color="secondary"
          keep-color
          size="xs"
          @update:model-value="toggleLink(link)"
        />
      </QBtn>
    </QBtnGroup>
  </div>
</template>
